import { render, staticRenderFns } from "./sideCircles.vue?vue&type=template&id=4f358ec6&"
import script from "./sideCircles.vue?vue&type=script&lang=js&"
export * from "./sideCircles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports